import styled from 'styled-components'
import {
  hFlex,
  vFlex,
} from '../../../../../../../../../../Styles/style-helpers'
import { H4 } from '../../../../../../../../../../Styles/typography'
import { accent } from '../../../../../../../../../../Styles/colors'

export const AssignmentUploaderEl = styled.div`
  display: block;
  position: relative;
  width: 100%;
  margin-top: 1em;
  background: #e9e9e9;
  border-radius: 1em;
  overflow: hidden;
  ${hFlex};
  padding: 2em;

  .content {
    max-width: 50em;
    min-width: 30em;
    z-index: 1;

    ${vFlex};
    width: 100%;
    position: relative;
    overflow: auto;
    justify-content: flex-start;
    padding-bottom: 1em;

    > ${H4} {
      width: 100%;
      text-align: center;
      margin-bottom: 1em;
      padding-left: 0.25em;
    }

    .action-btns {
      ${hFlex};
      justify-content: flex-end;
      margin-top: 1em;

      .retake-btn {
        ${hFlex};
        cursor: pointer;
        margin-right: 1.5em;

        svg {
          margin-right: 0.25em;
        }
      }
    }

    .review__content {
      padding: 1em;
      width: 100%;
      font-size: 1.125em;
      line-height: 1.33;
      background: #fff;
      border-radius: 0.5em;
      border: 1px solid ${accent};
      margin-top: 1em;
    }

    .video-container {
      width: 50%;

      video {
        border-radius: 0.5em;
      }
    }
  }
`
